import { Container } from 'components/ui';
import RegisterWrapper from 'components/Register';
import { wrapFunctionalComponent } from 'utils/framework';

/**
 * Register Page
 * Full-screen Register page that handles both regular Register and OAuth2 external authentication
 */
const Register = () => {
    return (
        <div>
            <Container is='main'>
                <RegisterWrapper />
            </Container>
        </div>
    );
};

export default wrapFunctionalComponent(Register, 'Register');
